'use client';

import { c as _c } from "react/compiler-runtime";
import type { Api } from '@cruz-com/lookup';
import _ from 'lodash';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi2';
import ResponsivePagination from 'react-responsive-pagination';
import { Button, CruzIcon } from '@/components';
import { abbNumber, encodeQuery } from '@/lib';
type Props = {
  meta: Api.Meta;
  onPageNumberChanged?: (val: number) => void;
} & React.ComponentPropsWithoutRef<'span'>;
export function Pagination(t0) {
  const $ = _c(67);
  const {
    meta,
    onPageNumberChanged
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const params = useSearchParams();
  let query;
  let t1;
  let t2;
  if ($[0] !== meta || $[1] !== params) {
    query = _.assign({}, _.pick(meta, "page_number"), Object.fromEntries(params));
    t1 = useState;
    t2 = _.toNumber(query?.page_number) || 1;
    $[0] = meta;
    $[1] = params;
    $[2] = query;
    $[3] = t1;
    $[4] = t2;
  } else {
    query = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const [currentPage, setCurrentPage] = t1(t2);
  const [limitReached, setLimitReached] = useState(false);
  let t3;
  if ($[5] !== query?.page_number) {
    t3 = () => {
      setCurrentPage(_.toNumber(query?.page_number) || 1);
    };
    $[5] = query?.page_number;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = query?.page_number;
  let t5;
  if ($[7] !== t4) {
    t5 = [t4];
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t3, t5);
  let t6;
  let t7;
  if ($[9] !== meta) {
    t6 = () => {
      const {
        record_limit,
        total_records_matched
      } = meta || {};
      setLimitReached(!!(record_limit && total_records_matched === record_limit));
    };
    t7 = [meta];
    $[9] = meta;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  meta?.total_pages;
  meta?.page_size;
  let t8;
  bb0: {
    if (!meta?.total_pages) {
      t8 = 0;
      break bb0;
    }
    const maxPages = Math.floor(10000 / (meta.page_size || 24));
    const x = Math.max(currentPage + 1, Math.min(meta.total_pages, 10));
    if (x < meta.total_pages) {
      t8 = Math.min(x, maxPages);
      break bb0;
    }
    t8 = Math.min(meta.total_pages, maxPages);
  }
  const totalPages = t8;
  if (!meta || _.isEmpty(meta)) {
    return null;
  }
  let t9;
  if ($[12] !== meta) {
    t9 = meta || {};
    $[12] = meta;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const {
    total_pages,
    page_number,
    record_limit: record_limit_0,
    total_records_matched: total_records_matched_0,
    total_records_matched_global,
    location
  } = t9;
  const tMatched = total_records_matched_0 || 0;
  const tMatchedGlobal = total_records_matched_global || 0;
  let t10;
  if ($[14] !== onPageNumberChanged || $[15] !== pathname || $[16] !== query || $[17] !== router) {
    t10 = pageNumber => {
      if (onPageNumberChanged) {
        onPageNumberChanged(pageNumber);
      }
      setCurrentPage(pageNumber);
      router.push(`${pathname}?${encodeQuery({
        ...query,
        page_number: pageNumber
      })}`);
    };
    $[14] = onPageNumberChanged;
    $[15] = pathname;
    $[16] = query;
    $[17] = router;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const handlePageClick = t10;
  let t11;
  if ($[19] !== pathname || $[20] !== query || $[21] !== router) {
    t11 = () => {
      router.push(`${pathname}?${encodeQuery({
        ...query,
        radius: -1,
        page_number: 1
      })}`);
    };
    $[19] = pathname;
    $[20] = query;
    $[21] = router;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const searchNationwide = t11;
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <HiChevronLeft className="size-6" aria-hidden="true" title="Previous Page" />;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <HiChevronRight className="size-6" aria-hidden="true" title="Next Page" />;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== currentPage || $[26] !== handlePageClick || $[27] !== totalPages) {
    t14 = <ResponsivePagination total={totalPages} current={currentPage} onPageChange={handlePageClick} previousLabel={t12} ariaPreviousLabel="Previous Page" nextLabel={t13} ariaNextLabel="Next Page" />;
    $[25] = currentPage;
    $[26] = handlePageClick;
    $[27] = totalPages;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== meta || $[30] !== page_number || $[31] !== query) {
    t15 = encodeQuery({
      ...query,
      ..._.pick(meta, "sort_value", "sort_page_number"),
      page_number: (page_number || 0) + 1
    });
    $[29] = meta;
    $[30] = page_number;
    $[31] = query;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const t16 = pathname + "?" + t15;
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="sr-only">Next Page</span>;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t16) {
    t18 = <a className="hidden p-4 text-center text-sm" rel="next" href={t16}>{t17}</a>;
    $[34] = t16;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const t19 = total_records_matched_0 || 0;
  let t20;
  if ($[36] !== t19) {
    t20 = abbNumber(t19, 2);
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t20) {
    t21 = <span className="font-medium">{t20}</span>;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== total_pages) {
    t22 = total_pages?.toLocaleString();
    $[40] = total_pages;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== t22) {
    t23 = <span className="font-medium">{t22}</span>;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  const t24 = (total_pages || 0) > 1 ? "s" : "";
  let t25;
  if ($[44] !== limitReached || $[45] !== record_limit_0) {
    t25 = limitReached && <div className="mt-1 text-xs">Note: Limit reached, showing top {record_limit_0?.toLocaleString()} results</div>;
    $[44] = limitReached;
    $[45] = record_limit_0;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== location?.city || $[48] !== location?.distance || $[49] !== location?.state_abbr || $[50] !== meta?.location) {
    t26 = meta?.location && (location?.distance || 0) > 0 && <div>Searching within <span className="font-medium">{meta?.location?.distance?.toLocaleString()} miles</span> of{" "}<span className="font-medium">{location?.city}, {location?.state_abbr}</span></div>;
    $[47] = location?.city;
    $[48] = location?.distance;
    $[49] = location?.state_abbr;
    $[50] = meta?.location;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== searchNationwide || $[53] !== tMatched || $[54] !== tMatchedGlobal) {
    t27 = tMatchedGlobal > 0 && tMatchedGlobal > tMatched && <div className="mt-6 flex items-center justify-center gap-x-4 text-sm font-light"><CruzIcon.Tips className="size-7" aria-hidden="true" /><span><span className="font-semibold">{tMatchedGlobal.toLocaleString()}</span> vehicles found{" "}<span className="font-medium">nationwide</span></span><Button className="h-9 rounded-full px-5" onClick={searchNationwide} aria-label="Search Nationwide"><CruzIcon.Search aria-hidden="true" />Search Nationwide</Button></div>;
    $[52] = searchNationwide;
    $[53] = tMatched;
    $[54] = tMatchedGlobal;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t21 || $[57] !== t23 || $[58] !== t24 || $[59] !== t25 || $[60] !== t26 || $[61] !== t27) {
    t28 = <div className="mt-6 text-center text-sm/6 font-light" aria-live="polite" aria-atomic="true">Total {t21} results,{" "}{t23} page{t24}.{t25}{t26}{t27}</div>;
    $[56] = t21;
    $[57] = t23;
    $[58] = t24;
    $[59] = t25;
    $[60] = t26;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== t14 || $[64] !== t18 || $[65] !== t28) {
    t29 = <nav aria-label="Pagination Navigation" className="mx-auto max-w-[600px] pt-10 text-center">{t14}{t18}{t28}</nav>;
    $[63] = t14;
    $[64] = t18;
    $[65] = t28;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  return t29;
}